/**
 * Servicio que conecta con la API las inspecciones de las incidencias
 */
EnvioEntidadService.$inject = ['$resource'];
export default function EnvioEntidadService($resource) {
    var urlBase = Sigo.var.path + '/api/v1' + '/entidad-envio' + '/:envioEntidadId';

    return $resource(urlBase, {
            envioEntidadId: '@envioEntidadId',
            tipo: '@tipo',
            id: '@id'
        }, {
            'query': {method: 'GET', isArray: false},
            'edit': {method: 'GET', url: urlBase + '/edit'},
            'update': {method: 'PUT'}
        }
    );
}